import { makeStyles } from "@mui/styles";
import useTheme from "@mui/material/styles/useTheme";

export const useCustomStyle = makeStyles(() => {
  const theme = useTheme();
  return {
    mainStyleWrapper: {
      position: "relative",
      maxWidth: "820px",
      margin: "auto",
      "& .textFiled": {
        marginBottom: "40px",
        [theme.breakpoints.down("md")]: {
          marginBottom: "30px",
        },
      },
      "& .textFiledLast": {
        marginBottom: "0px",
        "& .Platform-x-Autocomplete-hasClearIcon": {
          "& .Platform-x-TextField-root .Platform-x-InputBase-fullWidth": {
            padding: "14px",
          },
        },
      },
    },
  };
});
